export var shippingUpdateFailure = function shippingUpdateFailure(t) {
  return {
    severity: 'error',
    message: t('The shipping address could not be saved to your profile at this time'),
    duration: 'long'
  };
}; // Shows the specific, user-actionable validation reason the server returned
// (e.g. "Address is too long (maximum is 35 characters)") instead of the
// generic redemption-failure alert. Used when the redeem mutation returns a
// validation error carrying extensions.fullMessages.

export var redemptionValidationFailure = function redemptionValidationFailure(message) {
  return {
    severity: 'error',
    message: message,
    duration: 'long'
  };
};